export default {
  // jawline
  0: 1,
  1: 2,
  2: 2,
  3: 2,
  4: 1,
  5: 2,
  6: 2,
  7: 2,
  8: 1,
  9: 2,
  10: 2,
  11: 2,
  12: 1,
  13: 2,
  14: 2,
  15: 2,
  16: 1,
  // eyebrows
  17: 1,
  18: 2,
  19: 2,
  20: 2,
  21: 1,
  22: 1,
  23: 2,
  24: 2,
  25: 2,
  26: 1,
  // nose
  27: 1,
  28: 2,
  29: 2,
  30: 1,
  // nostrils
  31: 1,
  32: 2,
  33: 1,
  34: 2,
  35: 1,
  // left eye
  36: 2,
  37: 1,
  38: 1,
  39: 2,
  40: 1,
  41: 1,
  // right eye
  42: 2,
  43: 1,
  44: 1,
  45: 2,
  46: 1,
  47: 1,
  // upper lip outline
  48: 1,
  49: 2,
  50: 1,
  51: 1,
  52: 1,
  53: 2,
  54: 1,
  // lower lip outline
  55: 2,
  56: 1,
  57: 1,
  58: 1,
  59: 2,
  // lower lip inner
  60: 2,
  61: 2,
  62: 2,
  63: 2,
  64: 2,
  // upper lip inner
  65: 2,
  66: 2,
  67: 2
}
